import { createSlice } from '@reduxjs/toolkit';
import { fetchpaymentDetails } from './api';
import { reducers } from './reducers';

const initialState = {
  hotelDetails: {},
  isAndroid: false,
};

const stripeSlice = createSlice({
  initialState,
  name: 'stripe',
  extraReducers: (builder) => {
    builder
      // CASE FOR USER SIGN IN --->>>
      .addCase(fetchpaymentDetails.pending, (state) => {
        state.hotelDetails = {};
      })
      .addCase(fetchpaymentDetails.fulfilled, (state, { payload }) => {
        state.hotelDetails = payload;
      })
      .addCase(fetchpaymentDetails.rejected, (state, { payload }) => {
        state.hotelDetails = {};
      });
  },
  reducers,
});
export const stripeAction = stripeSlice.actions;
export default stripeSlice.reducer;
export const stripeSelector = (state) => state.stripe;
